import React from 'react';
import PropTypes from 'prop-types';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import RelationshipLinkButtons from 'Components/ComponentLibrary/Organisms/RelationshipLinkButtons';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const RelationshipLinks = ({ resource }) => {
  const { loadPageContentLink } = usePageContentContext();
  const { loadModalCollectionByLink, clearModalCollection } = useModalContext();

  const handleLinkClick = async (rel) => {
    if (rel.meta('isPageNavigation')) {
      await loadPageContentLink(rel.link('related'));
      clearModalCollection();
    } else {
      loadModalCollectionByLink(rel.link('related').url());
    }
  };

  return (
    <RelationshipLinkButtons
      onClick={handleLinkClick}
      resource={resource}
    />
  );
};

RelationshipLinks.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default RelationshipLinks;
